import { render, staticRenderFns } from "./ClassLikeDislike.vue?vue&type=template&id=1fe72fab&"
import script from "./ClassLikeDislike.vue?vue&type=script&lang=ts&"
export * from "./ClassLikeDislike.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports